import { Injectable } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { DisclaimerModalActionsEnum, DisclaimerModalOptions } from '../models';
import { DisclaimerModalComponent, DEFAULT_DISCLAIMER_MODAL_OPTIONS } from '../disclaimer-modal.component';

const DEFAULT_DISCLAIMER_MODAL_CONFIG: NgbModalOptions = {
  centered: true,
  backdrop: 'static',
  keyboard: false,
  size: 'lg',
};

@Injectable()
export class DisclaimerModalService {
  constructor(private readonly ngBootstrapModalService: NgbModal) {}

  public showDisclaimerModal(
    disclaimerOptions: DisclaimerModalOptions = DEFAULT_DISCLAIMER_MODAL_OPTIONS,
    options: NgbModalOptions = DEFAULT_DISCLAIMER_MODAL_CONFIG,
  ): Promise<DisclaimerModalActionsEnum> {
    const modalRef = this.ngBootstrapModalService.open(DisclaimerModalComponent, options);

    const modal: DisclaimerModalComponent = modalRef.componentInstance;
    modal.modalOptions = { ...DEFAULT_DISCLAIMER_MODAL_OPTIONS, ...disclaimerOptions };
    modal.modalAction.subscribe((action: DisclaimerModalActionsEnum) => {
      modalRef.close(action);
    });

    return modalRef.result;
  }
}
